import type { Locale } from '../store/locale.store';

/** Etiqueta BCP-47 que usa `Intl` para cada idioma del dashboard. */
export const INTL_LOCALE_TAG: Record<Locale, string> = {
  es: 'es-MX',
  en: 'en-US',
  zh: 'zh-CN',
};

/** Devuelve la etiqueta BCP-47 del idioma activo (es→es-MX, en→en-US, zh→zh-CN). */
export function intlLocaleTag(locale: Locale | string | undefined): string {
  return INTL_LOCALE_TAG[locale as Locale] ?? INTL_LOCALE_TAG.es;
}

export function formatNumber(value: number, locale: Locale | string | undefined, options?: Intl.NumberFormatOptions): string {
  return value.toLocaleString(intlLocaleTag(locale), options);
}

export function formatDateTime(value: Date | string | number, locale: Locale | string | undefined, options?: Intl.DateTimeFormatOptions): string {
  return new Date(value).toLocaleString(intlLocaleTag(locale), options);
}

export function formatDateOnly(value: Date | string | number, locale: Locale | string | undefined, options?: Intl.DateTimeFormatOptions): string {
  return new Date(value).toLocaleDateString(intlLocaleTag(locale), options);
}

export function formatTimeOnly(value: Date | string | number, locale: Locale | string | undefined, options?: Intl.DateTimeFormatOptions): string {
  return new Date(value).toLocaleTimeString(intlLocaleTag(locale), options);
}
